/**
 * Typed Registration / Onboarding API call wrappers.
 */
import type { AxiosResponse } from 'axios';
import apiClient from '../apiClient';
import { API_ENDPOINTS } from '../endpoints';
import type {
  CreateAccountRequest,
  CreateAccountResponse,
  QuestionnaireRequest,
  BuddyMatch,
} from './onboardingTypes';

const onboardingApi = {
  /**
   * POST /api/v1/Registration/OnboardingCreateAccount (Step 1 — Signup)
   */
  createAccount: (
    payload: CreateAccountRequest,
  ): Promise<AxiosResponse<CreateAccountResponse>> =>
    apiClient.post<CreateAccountResponse>(
      API_ENDPOINTS.REGISTRATION.CREATE_ACCOUNT,
      payload,
    ),

  /**
   * POST /api/v1/Registration/OnboardingCreateAccountSSO (Step 1 SSO — Signup)
   */
  createAccountSSO: (
    payload: import('./onboardingTypes').CreateAccountSSORequest,
  ): Promise<AxiosResponse<CreateAccountResponse>> =>
    apiClient.post<CreateAccountResponse>(
      API_ENDPOINTS.REGISTRATION.CREATE_ACCOUNT_SSO,
      payload,
    ),

  /**
   * POST /api/v1/Registration/OnboardingProfileInfo (Step 2 — Basic Info)
   * multipart/form-data matching schema:
   * UserGUID (uuid), Gender (string), CountryID (int32), HeightCM (double),
   * HeightUnit (string), WeightKG (double), WeightUnit (string),
   * DateOfBirth (calendar `YYYY-MM-DD`), ProfilePicture (binary)
   */
  saveProfileInfo: (payload: FormData): Promise<AxiosResponse<void>> =>
    apiClient.post<void>(API_ENDPOINTS.REGISTRATION.PROFILE_INFO, payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  /**
   * POST /api/v1/Registration/OnboardingQuestionnaire (Step 3 — Survey)
   */
  submitQuestionnaire: (
    payload: QuestionnaireRequest,
  ): Promise<AxiosResponse<BuddyMatch>> =>
    apiClient.post<BuddyMatch>(
      API_ENDPOINTS.REGISTRATION.QUESTIONNAIRE,
      payload,
    ),
};

export default onboardingApi;
